import { type I18nWording } from '@/services/i18n';

export const trimI18nWording = (wording: I18nWording): I18nWording =>
  Object.fromEntries(
    Object.entries(wording).map(([locale, value]) => [locale, value?.trim()])
  ) as I18nWording;
